import { useRouter } from '@tanstack/react-router'
import { HistoryLink } from 'commons/types/DTO/bank/historyAudit'
import { camelCase } from 'lodash'
import { DownloadLink, Link } from 'ui/components'
import { getDirectDownloadLinkByEntityType } from '~bank-entity-history/utils/getDirectDownloadLinkByEntityType'
import { getLinkByEntityType } from '~bank-entity-history/utils/getLinkByEntityType'

import { SC } from './styles'

type HeaderLinkProps = HistoryLink

export const HeaderLink = ({ definition, title, id, entityType, additionalId, type, ...rest }: HeaderLinkProps) => {
  const router = useRouter()

  switch (type) {
    case 'download':
      return (
        <SC.Row>
          <DownloadLink
            direct
            baseUrl={getDirectDownloadLinkByEntityType(entityType)}
            parametersForm={{ id: Number(id) }}
            handleError={() => ({})}
            name={title}
          >
            <span data-qa={`details-${camelCase(definition)}-field-label`}>{definition} - </span>
            {title}
          </DownloadLink>
        </SC.Row>
      )
    case 'adverse_media_scan_result_download':
      return (
        <SC.Row>
          <DownloadLink
            direct
            baseUrl={getDirectDownloadLinkByEntityType(entityType)}
            parametersForm={{
              attachment: true,
              caseId: rest.caseId,
              kind: rest.resultKind,
              scanId: rest.scanId
            }}
            handleError={() => ({})}
            name={title}
          >
            <span data-qa={`details-${camelCase(title)}-field-label`}> {title}</span>
          </DownloadLink>
        </SC.Row>
      )
    case 'no_link':
      return (
        <SC.Row>
          <span data-qa={`details-${camelCase(definition)}-field-label`}>{definition}</span> - {title}
        </SC.Row>
      )
    default:
      return (
        <SC.Row>
          <span data-qa={`details-${camelCase(definition)}-field-label`}>{definition}</span> -{' '}
          <Link
            to={id ? getLinkByEntityType(entityType, id, router, additionalId) : ''}
            data-qa={`details-${camelCase(definition)}-field-value`}
          >
            {title}
          </Link>
        </SC.Row>
      )
  }
}
